import ChartGroupingLevelSelectorFillingStrategy from './ChartGroupingLevelSelectorFillingStrategy'

function UsersGroupsCPMonthsWeeksDaysGroupingLevelSelectorFillingStrategy() {}

UsersGroupsCPMonthsWeeksDaysGroupingLevelSelectorFillingStrategy.prototype = new ChartGroupingLevelSelectorFillingStrategy();

UsersGroupsCPMonthsWeeksDaysGroupingLevelSelectorFillingStrategy.prototype.fillGroupingLevelListSelector = function( listSelector )
{
    this.addUsersItem( listSelector );
    this.addUserGroupsItemIfNeeded( listSelector );
    this.addTimeZoneGroupsItemIfNeeded( listSelector );

    listSelector.addSeparator();

    this.addCustomersItem( listSelector );
    this.addProjectsItem( listSelector );
    this.addTypesOfWorkItemIfNeeded( listSelector );
    listSelector.addSeparator();
    this.addDaysItem( listSelector );
    this.addWeeksItem( listSelector );
    this.addMonthsItem( listSelector );
};

export default UsersGroupsCPMonthsWeeksDaysGroupingLevelSelectorFillingStrategy


// WEBPACK FOOTER //
// ./web/js/reports/charts/UsersGroupsCPMonthsWeeksDaysGroupingLevelSelectorFillingStrategy.js